import React from "react";

export class Footer extends React.Component {
  render() {
    let fecha = new Date().getFullYear();

    return (
      <footer id="footer" className="sticky-footer bg-white">
        <div className="container my-auto">
          <div className="copyright text-center my-auto">
            <span>Derechos Reservados &copy; SUGEF {fecha} </span>
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;
